// extracted by mini-css-extract-plugin
export default {"Container":"Button_Container__hL4TP","Label":"Button_Label__L0JXc"};